import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

import { LogoColored } from '../../../assets'
import { ROUTER } from '../../../class/constants'
import { Grid } from '@material-ui/core'
import { Alert, Label } from '../../default'

import { CardPaper } from '../../cards'

const StartScreen = ({
  classes, isAuth, children, Form, recoverSuccess, hideLogo, description, width, maxWidth
}) => {
  const { t } = useTranslation()

  if (isAuth)
    return <Redirect to={{ pathname: ROUTER.MAIN }} />

  return (
      <Grid
        container
        spacing={3}             
        justify="center"
        alignItems="center"
        className={classes.root}
      >
        <Grid item style={{ width, maxWidth: width ? width : undefined }}>
          <CardPaper className={classes.card}>
            {
              hideLogo ? null : (
                <div className={classes.imgForm}>
                  <img
                    src={LogoColored}
                    alt='Logo'
                    style={{ maxHeight: '122px', maxWidth: '223px' }}
                  />
                </div>
              )
            }
            {
              recoverSuccess ? (
                <Alert color="success" variant="filled" text={t('screens.loginScreen.recoverSuccess')} />
              ) : null
            }
            {
              description ? (
                <Label color="secondary">{description}</Label>
              ) : null
            }
            <Form />
            {children}
          </CardPaper>
        </Grid>
      </Grid>
  )
}

const mapStateToProps = state => ({
  isAuth: state.ReducerAuth.isAuth
})

StartScreen.propTypes = {
  Form: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
    PropTypes.elementType,
  ]).isRequired,
}

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1,
    overflowX: 'hidden',
    overflowY: 'auto',
    minHeight: '100vh',
    overflow: 'auto',
    paddingTop: theme.spacing(5),
    background: theme.palette.background.startScreen,
    backgroundPosition: 'center bottom 59%'
  },
  imgForm: {
    display: 'flex',
    flex: 3,
    flexFlow: 'row nowrap',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  card: {
    padding: '25px',
    marginBottom: theme.spacing(4)
  }
})

export default connect(mapStateToProps)(withStyles(styles)(StartScreen))
